angular.module("app").directive("fashionFiveYearColorComparison", () => {
  let link = (scope) => {
    scope.regions = [
      "All",
      "Europe",
      "North America",
      "South America",
      "Asia",
      "Australia",
      "Africa"
    ];
    scope.blackMode = false;
    scope.selectedRegion = scope.regions[0];
    scope.isSelectedRegion = (region) => {
      return scope.selectedRegion === region;
    };
    scope.selectRegion = (region) => {
      scope.selectedRegion = region;
    };
    scope.switchGraph = () => {  
      if (scope.blackMode) {
        scope.data = scope.fullData.filter(item => item.color.hex !== '#000000');
      } else {
        scope.data = scope.fullData;
      }
    };
  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbFashionFiveYearColorComparison/dbFashionFiveYearColorComparisonView.html",
    link: link,
    scope: {
      data: "=",
      name: "=",
      fullData: "="
    }
  };
});
